import { SliderScroll } from '../_app/cuchillo/components/SliderScroll';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { gsap } from "gsap";
import Scroll_Item from '../_app/cuchillo/scroll/Scroll_Item';
import VScroll_Item from '../_app/cuchillo/scroll/VScroll_Item';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Basics, isSmartphone } from '../_app/cuchillo/core/Basics';
import { Maths } from '../_app/cuchillo/utils/Maths';

class ScrollItem__Team extends Scroll_Item {
    _call;
    _slider;
    _current = -1;
    _total = 0;
    _visor;
    _items = [];

    //==================================================================================================================
    //          CONSTRUCTOR
    //==================================================================================================================
    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        if (!isSmartphone) {
            this._visor = GetBy.class("__visor", this.item);

            this.setupVisor();

            this.onMove = () => {
                const p = this.progressInside;
                const next = Math.max(Math.floor(this._total * p), 0);
                this.showNext(next);
            };

            this._call = (e) => this.hover(e);
            document.addEventListener(Basics.moveEvent, this._call);
            this.showNext(0);
        }
    }

    hideNext(next) {
        if (next < 0) return;

        this._items[next].member.style.opacity = 0;
    }

    showNext(next) {
        if (this._current == next) return;
        if (next >= this._total) return;

        if (this._current >= 0) {
            this._items[this._current].image.classList.remove("--show");
            this._items[this._current].member.classList.remove("--show");
        }

        this._items[next].image.classList.add("--show");
        this._items[next].member.classList.add("--show");
        this._current = next;
    }


    setupVisor() {
        const items = [...GetBy.class("__item", this.visor)];
        const members = [...GetBy.class("__member", this.visor)];

        for (let i = 0; i < items.length; i++) {
            this._total = this._items.push({
                image: items[i],
                member: members[i]
            });
        }
    }

    hover(e) {
        // switch (e.target.tagName.toLowerCase()) {
        //     case "a":
        //NOT ANCHOR
        const n = e.target.getAttribute("data-index");
        if (n) {
            this.showNext(Number(n));
        }

        //         break;
        // }
    }

    loop() { }

    dispose() {
        super.dispose();
        if (!isSmartphone) document.removeEventListener(Basics.moveEvent, this._call);
    }
}

Scroll._registerClass('Team', ScrollItem__Team);
